module.exports = __webpack_public_path__ + "static/fiji1-755714c9bf2d59b4876775a3d4218b72.png";